import ProductTransformer from './ProductTransformer';

export default class ProductReservationConfirmationTransformer extends ProductTransformer {
  static addFootnote(fn, product) {
    if (fn.name === 'footNoteReservation') {
      product.footnotes.push(fn.text);
    }
  }

  static parseFootnotes(product, footnotes) {
    ['beforeOptinInfoText', 'reservationHint'].forEach(field => {
      product.texts[field] = footnotes.parse(product.texts[field]);
    });
  }
}
